var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/24/edit") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M21.0009101,19.1213914 C21.5531949,19.1213914 22.0009101,19.5691067 22.0009101,20.1213914 C22.0009101,20.6736762 21.5531949,21.1213914 21.0009101,21.1213914 L21.0009101,21.1213914 L12.0009101,21.1213914 C11.4486254,21.1213914 11.0009101,20.6736762 11.0009101,20.1213914 C11.0009101,19.5691067 11.4486254,19.1213914 12.0009101,19.1213914 L12.0009101,19.1213914 Z M18.8087673,2.1064275 C19.8859101,2.39504707 20.7272545,3.23639142 21.015874,4.31353429 C21.3044936,5.39067715 20.9965402,6.53997491 20.2080169,7.32849822 L7.70801688,19.8284982 C7.57985806,19.956657 7.41927818,20.0475758 7.24344573,20.0915339 L3.24344573,21.0915339 C2.51106526,21.2746291 1.84767248,20.6112363 2.0307676,19.8788558 L3.0307676,15.8788558 C3.07472571,15.7030234 3.1656445,15.5424435 3.29380332,15.4142847 L15.7938033,2.91428466 C16.5823266,2.12576135 17.7316244,1.81780794 18.8087673,2.1064275 Z M17.2080169,4.32849822 L4.90387412,16.632641 L4.37527864,18.7470229 L6.48966056,18.2184274 L18.7938033,5.91428466 C19.0770768,5.63101119 19.1877077,5.21813112 19.0840224,4.83117238 C18.9803371,4.44421363 18.6780879,4.14196444 18.2911292,4.03827916 C17.9041704,3.93459387 17.4912903,4.04522475 17.2080169,4.32849822 Z",
    id: "edit-path"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/24/edit",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "edit-mask",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#edit-path"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#edit-path"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#edit-mask)",
    fill: "currentcolor"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.10e83237660f7be64078d2e503f61a38.svg";
export { ForwardRef as ReactComponent };